module.exports = __webpack_public_path__ + "static/media/solution.8d2576f7.svg";